<template>
<v-container>
    <h1>Pricing</h1>
  <v-data-table
    :headers="headers"
    :items="prices"
    :disable-sort=true
    :hide-default-footer="true"
  ></v-data-table>
</v-container>
</template>

<script>
  export default {
    data () {
      return {
        headers: [
          {
            text: 'Item',
            align: 'start',
            value: 'name',
          },
          { text: 'Price',
            value: 'price' 
        }
        ],
        prices: [
          {
            name: 'Account',
            price: 'Free',
          },
            {
            name: 'Incoming Text',
            price: '$0.05 per message',
          },
        {
            name: 'Outgoing Text',
            price: '$0.05 per message',
          },
          {
            name: 'Handle',
            price: '$1 per year',
          }
        ],
      }
    },
  }
</script>